export const latexAccents = ['\\hat', '\\bar', '\\underbrace', '\\overbrace'];
